const route = [

  {
    path: "/admin",
    name: "Admin",
    component: require("@/views/Admin.vue").default,
    redirect: "/admin/home",
    meta: { 
      requiresAuth: true 
    },
    children: [

      {
        path: "home",
        name: "Beranda",
        component: require("@/views/Admin/AdminHome.vue").default,
      },

      {
        path: "profile",
        name: "Profil",
        component: require("@/views/Admin/AdminProfile.vue").default,
      },

      {
        path: "profileUpdate",
        name: "Update Profil Pengurus",
        component: require("@/components/UpdateProfile.vue").default
      },

      {
        path: "update",
        name: "Update Data Masjid",
        component: require("@/components/UpdateMasjid.vue").default
      },

      {
        path: "masjid",
        name: "Daftarkan Masjid",
        component: require("@/components/CreateMasjid.vue").default
      },

      {
        path: "display",
        name: "Display Masjid",
        component: require("@/views/Admin/AdminDisplayMasjid.vue").default
      },

      {
        path: "jamaah",
        name: "Jamaah",
        component: require("@/views/Admin/AdminJamaah.vue").default,
        redirect: "/admin/jamaah/submit",
        children: [

          {
            path: "submit",
            name: "Submit Data Jamaah",
            component: require("@/views/Admin/AdminJamaahSubmit.vue").default,
          },

          {
            path: "list",
            name: "List Data Jamaah",
            component: require("@/views/Admin/AdminJamaahList.vue").default,
          },

          {
            path: "statistik",
            name: "statistik-jamaah",
            component: require("@/views/Admin/AdminJamaahStatistik.vue").default,
          },

          {
            path: "blast",
            name: "blast-wa",
            component: require("@/views/Admin/AdminJamaahBlast.vue").default,
          },

          {
            path: "bot",
            name: "bot-wa",
            component: require("@/views/Admin/AdminJamaahBot.vue").default,
          }

        ],
      },

      {
        path: "keuangan",
        name: "Keuangan",
        component: require("@/views/Admin/AdminKeuangan.vue").default,
        redirect: "/admin/keuangan/submit",
        children: [
          {
            path: "submit",
            name: "Submit Keuangan Masjid",
            component: require("@/views/Admin/AdminKeuanganSubmit.vue").default,
          },
          {
            path: "list",
            name: "List Keuangan masjid",
            component: require("@/views/Admin/AdminKeuanganList.vue").default,
          },
          {
            path: "statistik",
            name: "Statistik keuangan masjid",
            component: require("@/views/Admin/AdminKeuanganStatistik.vue").default,
          }
        ]
      },

      {
        path: "kegiatan",
        name: "Kegiatan",
        component: require("@/views/Admin/AdminKegiatan.vue").default,
        redirect: "/admin/kegiatan/submit",
        children: [

          {
            path: "submit",
            name: "Tambahkan Kegiatan",
            component: require("@/views/Admin/AdminKegiatanSubmit.vue").default,
          },
          {
            path: "list",
            name: "List Kegiatan",
            component: require("@/views/Admin/AdminKegiatanList.vue").default,
          },
          {
            path: "submitMember/:masjid_program_uid",
            name: "Tambahkan Anggota Kegiatan",
            component: require("@/views/Admin/AdminKegiatanMemberSubmit.vue").default,
            props: true
          },
          {
            path: "listMember/:masjid_program_uid",
            name: "List Anggota Kegiatan",
            component: require("@/views/Admin/AdminKegiatanMemberList.vue").default,
            props: true,
          },
          {
            path: "uploadMember",
            name: "Upload Anggota Kegiatan",
            component: require("@/views/Admin/AdminKegiatanUploadMember.vue").default,
          },
          {
            path: "khotib",
            name: "Khatib Sholat Jumat",
            component: require("@/views/Admin/AdminSoljumList.vue").default
          },
          {
            path: "submitKhotib",
            name: "Tambahkan Khatib Sholat Jumat",
            component: require("@/views/Admin/AdminSoljumSubmit.vue").default
          }
        ],
      },
    ],
  },

]

export default route;